import { Box, Grid } from '@mui/material';

import { Typography, TextField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

export const VisitChallengeConfiguration = () => {
  return (
    <Box mt={2}>
      <Typography variant='subtitle1' gutterBottom>
        When They make
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <TextField
            name='visitChallenge.visitThreshold'
            label='Number of Visits'
            fieldProps={{
              parse: parseNumber,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
